<script setup lang="ts">
import { computed, reactive } from "vue"
import { nl as nlLocale } from "date-fns/locale"
import { getFormattedTime } from "@/helpers/timezone.helper";
import { ActiviteitLesWithTrainers } from "@/repositories/activiteit.repository";
import { compareAsc } from "date-fns";

const props = defineProps<{
    lessen: ActiviteitLesWithTrainers[]
}>()

const state = reactive({
    openedDropdown: [] as number[]
})

const orderedLessen = computed(() => {
    return [...props.lessen].sort((a, b) => compareAsc(a.BeginDatum, b.BeginDatum))
})

const isLesStarted = (item: ActiviteitLesWithTrainers) => {
    return new Date(item.BeginDatum).getTime() < Date.now();
}

const toggleDropdown = (value: number) => {
    
    const index = state.openedDropdown.indexOf(value);

    if (index == -1) {
        state.openedDropdown.push(value)
    } else {
        state.openedDropdown.splice(index, 1)
    }
}

const isOpen = (value: number) => {
    const index = state.openedDropdown.indexOf(value);
    return !(index == -1);
}
</script>

<template>
    <ul class="lesson-card-list list-unstyled" v-if="lessen && lessen.length">
        <li
            :class="[
                'lesson-card',
                isLesStarted(item) ? 'lesson-card--started' : 'lesson-card--upcoming',
                isOpen(index) ? '' : 'collapsed'
            ]"
            v-for="(item, index) in orderedLessen"
            :key="item.SportmomentLesId || index"
        >
            <div class="lesson-card-wrapper">
                <div class="lesson-card-header">
                    Les {{ index + 1 }}
                    <span v-if="isLesStarted(item)" class="lesson-card-status">
                        Afgelopen
                    </span>
                </div>
                <div class="lesson-card-content">
                    <div class="lesson-card-content-info">
                        <p class="info-title">
                            {{ item.Naam }}
                        </p>
                        <div class="info-date">
                            {{ getFormattedTime(item.BeginDatum, 'EEEE dd MMMM yyyy', nlLocale) }} · {{
                                getFormattedTime(item.BeginDatum, 'HH:mm', nlLocale) }} uur tot
                            {{ getFormattedTime(item.EindDatum, 'HH:mm', nlLocale) }} uur
                        </div>
                        <div class="lesson-card-expand" :class="isOpen(index) ? '' : 'collapse'" :id="`lesson-card-expand-${index}`">
                            <div class="lesson-card-expand-info">
                                <div class="expand-wrapper">
                                    {{ item.Beschrijving }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="lesson-card-content-button" @click="toggleDropdown(index)" v-if="item.Beschrijving">
                        <div class="icon-wrapper">
                            <span class="icon icon-collapse"></span>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</template>